
import { FlowDefinition } from "../../../core/flows/FlowDefinition";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { passengerDetailsInitStepDefinition } from "./Steps/PassengerDetailsInitStep";

export const passengerDetailsStartupFlow = new FlowDefinition("PassengerDetailsFlow");

passengerDetailsStartupFlow.addStep(passengerDetailsInitStepDefinition);

passengerDetailsStartupFlow.setStartStep("PassengerDetailsInit_Step");

export const passengerDetailsStepDefinition = new StepDefinition({
    stepName: "PassengerDetailsFlow",
    stepFlow: passengerDetailsStartupFlow,
    contextIsolation: false
})